import {
	Component,
	ViewEncapsulation,
	HostListener,
	ChangeDetectorRef
} from '@angular/core';

import { EventsService } from '@coreui/services/event.service'


@Component({
	selector: 		'paragraph',
	encapsulation: ViewEncapsulation.None,
	template:	`
		<div class="paragraph" onSurface font-family>
			<ng-content></ng-content>
		</div>
	`,

})


export class TypographyParagraphComponent {

	private changeDetectorRef: ChangeDetectorRef
    private eventsService: EventsService


	constructor(private ref: ChangeDetectorRef, private _eventsService: EventsService) {
		this.changeDetectorRef = ref
		this.eventsService = _eventsService
	}

	ngOnInit() {
	}

	ngAfterViewInit() {
	}

	ngOnDestroy() {
	}


}
